module.exports = __webpack_public_path__ + "static/img/case_detail_11_1.407d9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_11_1.png
// module id = 1GEd
// module chunks = 34